import HttpClient from '../../../services/http-client';
import { IMenuResponse } from '../../../../model/apm/menu/response/menu-response';
import { IMenuItemResponse } from '../../../../model/apm/menu/response/menu-item-response';
import { IMenuAddEditRequest } from '../../../../model/apm/menu/request/menu-add-edit-request';
import { IMenuItemAddEditRequest } from '../../../../model/apm/menu/request/menu-item-add-edit-request';

const defaultPath = 'Menu';

const list = async (): Promise<IMenuResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`
    }).then((response) => response.data || []);
};

const getById = async (id: number): Promise<IMenuResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IMenuAddEditRequest): Promise<IMenuResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IMenuAddEditRequest): Promise<IMenuResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const reorder = async (ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Order`,
        data: { ids }
    });
};

const addItem = async (menuId: number, params: IMenuItemAddEditRequest): Promise<IMenuItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${menuId}/Item`,
        data: params
    }).then((response) => response.data);
};

const editItem = async (menuId: number, itemId: number, params: IMenuItemAddEditRequest): Promise<IMenuItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${menuId}/Item/${itemId}`,
        data: params
    }).then((response) => response.data);
};

const removeItem = async (menuId: number, itemId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${menuId}/Item/${itemId}`
    });
};

const reorderItems = async (menuId: number, ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${menuId}/Item/Order`,
        data: { ids }
    });
};

const MenuAppService = { list, getById, add, edit, remove, reorder, addItem, editItem, removeItem, reorderItems };
export default MenuAppService;
